import React from "react";
import { RefreshCw } from "lucide-react";

import { CarregandoBloco, CarregandoCards, CarregandoTabela } from "../../../components/carregando";
import { Skeleton } from "../../../components/ui/skeleton";

/**
 * Carregamento com cards dos relatórios de ofertas (25/10/2026): no lugar do
 * círculo girando, o formato do relatório — frase do resumo, os cards de
 * número, os dois gráficos e a tabela — piscando até os dados chegarem.
 * `kpis`: quantos cards de número a página tem; `graficos`: false quando a
 * página não tem a dupla de gráficos; `frase`: false sem o quadro do resumo. Com `erro`, mostra o aviso com
 * "Tentar de novo" em vez de piscar para sempre.
 */
export default function Carregando({ kpis = 8, graficos = true, frase = true, erro = false, onTentar }) {
  if (erro) {
    return (
      <div className="rounded-xl border bg-card p-8 text-center space-y-3" data-e2e="relatorio-erro">
        <p className="text-sm text-muted-foreground">Não foi possível carregar o relatório agora.</p>
        {onTentar && (
          <button type="button" onClick={onTentar}
            className="inline-flex items-center gap-2 rounded-lg border px-3 py-1.5 text-sm font-semibold hover:bg-muted">
            <RefreshCw className="w-4 h-4" /> Tentar de novo
          </button>
        )}
      </div>
    );
  }
  return (
    <div className="space-y-5" aria-busy="true" aria-label="Carregando">
      {frase && <Skeleton className="h-[100px] w-full rounded-xl" />}
      <CarregandoCards quantos={kpis} />
      {graficos && (
        <div className="grid lg:grid-cols-5 gap-4">
          <CarregandoBloco altura="h-64" className="lg:col-span-3" />
          <CarregandoBloco altura="h-64" className="lg:col-span-2" />
        </div>
      )}
      <CarregandoTabela linhas={5} colunas={6} />
    </div>
  );
}
